import './header.scss';
import './toggle.scss';
import './modal.scss';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Navigation from './navigation/navigation';
import UserMenu from './user';
import Verify from './verify';
import { RoleIds } from '../../models';

function AppHeader({ showVerify }) {
    const [isActive, setActive] = useState(false);

    const handleToggle = () => {
        setActive(!isActive);
    };

    return (
        <>
            <div className="header">
                <div className="container">
                    <div className="content">
                        <Link
                            to="#"
                            id="toggle"
                            className={isActive ? 'open' : ''}
                            onClick={handleToggle}
                        >
                            <div id="nav-icon">
                                <span />
                                <span />
                                <span />
                                <span />
                            </div>
                        </Link>
                        <Link className="image" to="/">
                            <div className="logo" alt="Moyle Mink & Tannery Logo" />
                        </Link>
                        <div className="nav">
                            <Navigation handleToggle={handleToggle} />
                        </div>
                        <div>
                            <UserMenu />
                        </div>
                    </div>
                </div>
                {showVerify && <Verify />}
            </div>
            <div style={{ height: 80 + (showVerify ? 40 : 0) }} />
        </>
    );
}

AppHeader.propTypes = {
    showVerify: PropTypes.bool,
};

AppHeader.defaultProps = {
    showVerify: false,
};

const mapStateToProps = ({
    authentication: {
        user: { roleId, acumaticaCustomerId },
        loggedIn,
    },
}) => {
    const isAdmin = roleId === RoleIds.ADMIN;
    const isProClient = roleId === RoleIds.PROCLIENT;
    return {
        isAdmin,
        isProClient,
        showVerify: loggedIn && !isAdmin && !acumaticaCustomerId,
        isLoggedIn: loggedIn,
    };
};

export default connect(mapStateToProps)(AppHeader);
